import { Stage, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { stageClient, StagePathParameters, StageQueryParameters } from './StageClient';

const factory = createStudyEntityHookFactory<Stage, StagePathParameters & StageQueryParameters>(StudyEntityType.Stage);

export const useStages = factory.list(stageClient.list);
